import { cn } from '@creator/ui/utils/ui';
import type { LinkMeta } from '@src/types/link-meta';
import type { FC } from 'react';
import { memo, useMemo } from 'react';
import EditorViewOnlyLinkTool from '../EditorViewOnly/LinkTool/LinkTool';
import Icon from '../Icon/Icon';

interface LinkMetaPreviewProps {
    className?: string;
    linkMeta: LinkMeta;
    isEditMode?: boolean;
    onDelete: () => void;
}

const LinkMetaPreviewComponent: FC<LinkMetaPreviewProps> = props => {
    const { className, linkMeta, isEditMode, onDelete } = props;

    const externalLinkPreviewProps = useMemo(
        () => ({
            infoClassName: 'bg-gray-200 dark:bg-gray-700',
        }),
        []
    );

    const blockData = useMemo(
        () => ({
            meta: linkMeta,
            link: linkMeta.url,
        }),
        [linkMeta]
    );

    function renderDeleteIcon() {
        if (!isEditMode) return null;

        return (
            <div
                onClick={onDelete}
                className="absolute flex items-center justify-center transition rounded-full shadow-sm cursor-pointer hover:scale-105 h-7 w-7 right-4 top-4 z-1 bg-gray-50 dark:bg-gray-800 dark:shadow-sm "
            >
                <Icon name="close" className="text-gray-900 dark:text-gray-50 " />
            </div>
        );
    }

    function renderEditorViewOnlyLinkTool() {
        return <EditorViewOnlyLinkTool externalLinkPreviewProps={externalLinkPreviewProps} className="mt-2" blockData={blockData} />;
    }

    return (
        <div className={cn('relative rounded-md', className)}>
            {renderDeleteIcon()}
            {renderEditorViewOnlyLinkTool()}
        </div>
    );
};

export const LinkMetaPreview = memo(LinkMetaPreviewComponent);
